import React from 'react';
import { Chip } from '@mui/material';

// Small pill so users can tell at a glance they're inside the v2 module.
// Defaults to "v2" / secondary colour; props let callers override for tests.
export default function GenerationModeBadge({
  label = 'v2',
  color = 'secondary',
  size = 'small',
  variant = 'filled',
  title = 'Work Orders V2 (Beta)',
  sx,
}) {
  return (
    <Chip
      label={label}
      color={color}
      size={size}
      variant={variant}
      title={title}
      data-testid="generation-mode-badge"
      sx={{ fontWeight: 600, letterSpacing: 0.5, ...sx }}
    />
  );
}
